export default __webpack_public_path__ + "static/media/card-blog11.9b289981.jpg";